import getServiceArgsValue from './getServiceArgsValue'

/**
 * Finds a given function from the pool config serviceArgs.
 *
 * @param {HttpCachePoolConfig} poolConfig
 * @param {Array<string>|string} functionPath
 * @return {function(string, Array)}
 */
const getServiceArgsFunction = (poolConfig, functionPath) => getServiceArgsValue(poolConfig, functionPath, (value) => value)

export default getServiceArgsFunction
